import { render, staticRenderFns } from "./NewDesarrolladores.vue?vue&type=template&id=8484026a&scoped=true"
import script from "./NewDesarrolladores.vue?vue&type=script&lang=js"
export * from "./NewDesarrolladores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8484026a",
  null
  
)

export default component.exports